export default __webpack_public_path__ + "static/char-s-57-ko-4b525d77a2ba4c1fff11c723cda762c0.png";